/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import env from 'src/shared/env';

export function getEntryYears() {
  return axios
    .get(`${window.getLinkHomepage()}api/Book/GetEntryYears`)
    .then((data) => data.data);
}

export function getBookListInMonth({ groupType, month, year, pageSize, page }) {
  return axios
    .get(`${window.getLinkHomepage()}api/Book/GetByGroupTypeInMonth`, {
      params: {
        count: pageSize,
        index: (page - 1) * pageSize,
        grouptype: groupType,
        month,
        year,
      },
    })
    .then((data) => data.data);
}
